import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=ccff91ca&scoped=true&"
import script from "./BasePage.vue?vue&type=script&lang=js&"
export * from "./BasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccff91ca",
  null
  
)

export default component.exports